import { useState } from 'react';
import './InfoPages.css';

const ChevronIcon = () => (
  <svg className="info-faq__chevron" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);

const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const PageIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>
);

/* ── PAGE COMPONENTS ── */

const AboutUs = () => (
  <div>
    <div className="info-hero">
      <div className="info-hero__eyebrow">Our Story</div>
      <h2 className="info-hero__title">Crafting Unforgettable Journeys Since 2022</h2>
      <p className="info-hero__sub">We believe travel is more than just visiting places; it's about creating lasting memories, discovering new cultures, and finding a deeper connection with the world.</p>
    </div>

    <div className="info-stats">
      <div className="info-stat">
        <div className="info-stat__num">4+</div>
        <div className="info-stat__label">Years Experience</div>
      </div>
      <div className="info-stat">
        <div className="info-stat__num">250+</div>
        <div className="info-stat__label">Happy Travelers</div>
      </div>
      <div className="info-stat">
        <div className="info-stat__num">20+</div>
        <div className="info-stat__label">Destinations</div>
      </div>
    </div>

    <div className="info-section">
      <h3 className="info-section__title">Our Mission</h3>
      <p>To provide exceptional, curated travel experiences that inspire, enrich, and connect our clients to the world's most beautiful and culturally significant destinations.</p>
      <p>We strive to make every journey seamless, personalized, and truly extraordinary. Whether you're seeking a serene beach getaway, an adventurous trek through the mountains, or a cultural immersion in a vibrant city, our team of experts is dedicated to bringing your dream holiday to life.</p>
    </div>

    <div className="info-section">
      <h3 className="info-section__title">Meet Our Team</h3>
      <div className="info-team">
        <div className="info-team__card">
          <div className="info-team__img-container">
            <img 
              src="https://ik.imagekit.io/nextdream/images/harsh.png" 
              alt="Harsh Patel - Founder" 
              className="info-team__img"
            />
          </div>
          <div className="info-team__info">
            <div className="info-team__name">Harsh Patel</div>
            <div className="info-team__role">Founder</div>
            <p className="info-team__bio">Harsh founded Next Dream Holidays with a passion for designing deeply personal and transformative travel experiences. With over 10 years exploring the globe, he ensures every itinerary is crafted with meticulous attention to detail and a touch of magic.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const ContactUs = () => (
  <div>
    <div className="info-hero">
      <div className="info-hero__eyebrow">Get in Touch</div>
      <h2 className="info-hero__title">We're Here to Help You Plan</h2>
      <p className="info-hero__sub">Have questions about a destination? Need assistance with an existing booking? Our travel experts are ready to assist you.</p>
    </div>

    <div className="info-contact-grid">
      <div className="info-contact-card">
        <div className="info-contact-card__icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
        </div>
        <div>
          <div className="info-contact-card__label">Phone Support</div>
          <div className="info-contact-card__val">+91 97244 12383</div>
          <div className="info-contact-card__note">Mon-Sat, 10am - 7pm IST</div>
        </div>
      </div>
      <div className="info-contact-card">
        <div className="info-contact-card__icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
        </div>
        <div>
          <div className="info-contact-card__label">Email Us</div>
          <div className="info-contact-card__val">nextdreamholidays07@gmail.com</div>
          <div className="info-contact-card__note">We reply within 24 hours</div>
        </div>
      </div>
      <div className="info-contact-card" style={{ gridColumn: '1 / -1' }}>
        <div className="info-contact-card__icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
        </div>
        <div>
          <div className="info-contact-card__label">Our Office</div>
          <div className="info-contact-card__val">FF-12, Sarthak Fortune Mall, Randesan-Kudasan, 382426, Gandhinagar, Gujarat, India.</div>
          <div className="info-contact-card__note">Appointments recommended for in-person visits</div>
        </div>
      </div>
    </div>
  </div>
);

const FAQs = () => {
  const [open, setOpen] = useState(0);
  const faqs = [
    { q: "How do I book a tour?", a: "You can book directly through our website by selecting your desired destination and clicking 'Book Now'. Alternatively, you can contact our travel experts for a custom itinerary." },
    { q: "Are flights included in the tour packages?", a: "Unless explicitly stated in the tour highlights, international flights are generally not included. We can, however, assist you in booking the best available flights for your journey." },
    { q: "What is your cancellation policy?", a: "Our cancellation policy varies depending on the tour and the time of cancellation. Please refer to our Refund Policy page for detailed information." },
    { q: "Do I need travel insurance?", a: "We strongly recommend purchasing comprehensive travel insurance that covers trip cancellations, medical emergencies, and lost baggage." },
    { q: "Are the tours suitable for children?", a: "Many of our tours are family-friendly. The minimum age requirement varies by tour type. Please check the specific tour details or contact us for family recommendations." }
  ];

  return (
    <div>
      <div className="info-hero">
        <div className="info-hero__eyebrow">Help Center</div>
        <h2 className="info-hero__title">Frequently Asked Questions</h2>
        <p className="info-hero__sub">Find quick answers to common questions about booking, preparing for your trip, and our policies.</p>
      </div>

      <div className="info-faq">
        {faqs.map((faq, i) => (
          <div key={i} className={`info-faq__item ${open === i ? 'open' : ''}`}>
            <button className="info-faq__q" onClick={() => setOpen(open === i ? -1 : i)}>
              {faq.q}
              <ChevronIcon />
            </button>
            <div className="info-faq__a">{faq.a}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const BookingGuide = () => (
  <div>
    <div className="info-hero">
      <div className="info-hero__eyebrow">How to Book</div>
      <h2 className="info-hero__title">Your Journey Starts Here</h2>
      <p className="info-hero__sub">A simple, step-by-step guide to booking your next dream holiday with us.</p>
    </div>

    <div className="info-steps">
      <div className="info-step">
        <div className="info-step__line">
          <div className="info-step__num">1</div>
          <div className="info-step__connector"></div>
        </div>
        <div className="info-step__content">
          <h3 className="info-step__title">Explore Destinations</h3>
          <p className="info-step__desc">Browse our curated list of destinations and tours. Read through the itineraries, highlights, and customer reviews to find the perfect trip for you.</p>
        </div>
      </div>
      <div className="info-step">
        <div className="info-step__line">
          <div className="info-step__num">2</div>
          <div className="info-step__connector"></div>
        </div>
        <div className="info-step__content">
          <h3 className="info-step__title">Customize & Consult (Optional)</h3>
          <p className="info-step__desc">Want to tweak the itinerary? Schedule a free consultation with our travel experts to customize your trip to your exact preferences.</p>
        </div>
      </div>
      <div className="info-step">
        <div className="info-step__line">
          <div className="info-step__num">3</div>
          <div className="info-step__connector"></div>
        </div>
        <div className="info-step__content">
          <h3 className="info-step__title">Secure Your Booking</h3>
          <p className="info-step__desc">Once you've chosen your tour, click 'Book Now'. Fill in your details and pay the initial deposit to secure your spot.</p>
        </div>
      </div>
      <div className="info-step">
        <div className="info-step__line">
          <div className="info-step__num">4</div>
          <div className="info-step__connector"></div>
        </div>
        <div className="info-step__content">
          <h3 className="info-step__title">Get Ready to Travel</h3>
          <p className="info-step__desc">You'll receive a detailed booking confirmation and travel guide. The remaining balance is typically due 60 days before departure.</p>
        </div>
      </div>
    </div>
  </div>
);

const RefundPolicy = () => (
  <div>
    <div className="info-hero">
      <div className="info-hero__eyebrow">Policies</div>
      <h2 className="info-hero__title">Cancellation & Refund Policy</h2>
      <p className="info-hero__sub">We understand that plans can change. Here is our transparent policy regarding cancellations and refunds.</p>
    </div>

    <div className="info-section">
      <h3 className="info-section__title">Standard Cancellation Terms</h3>
      <ul className="info-policy-list">
        <li><strong>More than 60 days before departure:</strong> Loss of deposit only.</li>
        <li><strong>30 to 59 days before departure:</strong> 50% of the total tour cost is non-refundable.</li>
        <li><strong>15 to 29 days before departure:</strong> 75% of the total tour cost is non-refundable.</li>
        <li><strong>Less than 14 days before departure:</strong> 100% of the total tour cost is non-refundable.</li>
      </ul>
    </div>

    <div className="info-alert info-alert--warn">
      <div className="info-alert__icon">⚠️</div>
      <div className="info-alert__text">
        <strong>Note:</strong> Some customized tours or special events may have stricter cancellation policies. These will be clearly communicated during the booking process.
      </div>
    </div>

    <div className="info-section">
      <h3 className="info-section__title">Refund Process</h3>
      <p>Eligible refunds will be processed to the original method of payment within 10-14 business days of receiving the written cancellation request.</p>
    </div>
  </div>
);

const TravelInsurance = () => (
  <div>
    <div className="info-hero">
      <div className="info-hero__eyebrow">Safety First</div>
      <h2 className="info-hero__title">Protect Your Journey</h2>
      <p className="info-hero__sub">Travel insurance provides peace of mind against the unexpected. We strongly recommend coverage for all our travelers.</p>
    </div>

    <div className="info-section">
      <p>While we do everything to ensure your trip runs smoothly, unforeseen events can happen. Comprehensive travel insurance protects your financial investment and ensures you get the help you need in an emergency.</p>
    </div>

    <div className="info-ins-grid">
      <div className="info-ins-card">
        <div className="info-ins-card__icon">🏥</div>
        <div className="info-ins-card__title">Medical Emergencies</div>
        <div className="info-ins-card__desc">Coverage for hospital visits, emergency medical evacuations, and unforeseen illness during your trip.</div>
      </div>
      <div className="info-ins-card">
        <div className="info-ins-card__icon">✈️</div>
        <div className="info-ins-card__title">Trip Cancellation</div>
        <div className="info-ins-card__desc">Reimbursement for non-refundable expenses if you need to cancel your trip due to covered reasons like illness or family emergencies.</div>
      </div>
      <div className="info-ins-card">
        <div className="info-ins-card__icon">🧳</div>
        <div className="info-ins-card__title">Baggage Loss</div>
        <div className="info-ins-card__desc">Compensation for lost, stolen, or damaged luggage and personal belongings.</div>
      </div>
      <div className="info-ins-card">
        <div className="info-ins-card__icon">⏱️</div>
        <div className="info-ins-card__title">Travel Delays</div>
        <div className="info-ins-card__desc">Coverage for essential expenses incurred due to significant travel delays.</div>
      </div>
    </div>

    <div className="info-alert info-alert--info" style={{ marginTop: '24px' }}>
      <div className="info-alert__icon">ℹ️</div>
      <div className="info-alert__text">
        We partner with global insurance providers. Ask our team for a personalized insurance quote when booking your tour.
      </div>
    </div>
  </div>
);

const TravelBlog = () => (
  <div>
    <div className="info-hero">
      <div className="info-hero__eyebrow">Inspiration</div>
      <h2 className="info-hero__title">Stories from the Road</h2>
      <p className="info-hero__sub">Discover travel guides, tips, and inspiring stories from our experts and travelers around the globe.</p>
    </div>

    <div className="info-blog-grid">
      <div className="info-blog-card">
        <div className="info-blog-card__img" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1533929736458-ca588d08c8be?auto=format&fit=crop&w=600&q=80)' }}></div>
        <div className="info-blog-card__body">
          <div className="info-blog-card__tag">Guide</div>
          <h3 className="info-blog-card__title">A Beginner's Guide to Exploring the Amalfi Coast</h3>
          <div className="info-blog-card__meta">May 12, 2026 • 5 min read</div>
        </div>
      </div>
      <div className="info-blog-card">
        <div className="info-blog-card__img" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=600&q=80)' }}></div>
        <div className="info-blog-card__body">
          <div className="info-blog-card__tag">Tips</div>
          <h3 className="info-blog-card__title">Packing Essentials for a 2-Week Safari</h3>
          <div className="info-blog-card__meta">April 28, 2026 • 4 min read</div>
        </div>
      </div>
      <div className="info-blog-card">
        <div className="info-blog-card__img" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1493246507139-91e8fad9978e?auto=format&fit=crop&w=600&q=80)' }}></div>
        <div className="info-blog-card__body">
          <div className="info-blog-card__tag">Destinations</div>
          <h3 className="info-blog-card__title">Hidden Gems of Kyoto: Beyond the Temples</h3>
          <div className="info-blog-card__meta">March 15, 2026 • 7 min read</div>
        </div>
      </div>
      <div className="info-blog-card">
        <div className="info-blog-card__img" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=600&q=80)' }}></div>
        <div className="info-blog-card__body">
          <div className="info-blog-card__tag">Inspiration</div>
          <h3 className="info-blog-card__title">Why Sustainable Travel Matters More Than Ever</h3>
          <div className="info-blog-card__meta">February 10, 2026 • 6 min read</div>
        </div>
      </div>
    </div>
  </div>
);

const PrivacyPolicy = () => (
  <div>
    <div className="info-hero">
      <div className="info-hero__eyebrow">Legal</div>
      <h2 className="info-hero__title">Privacy Policy</h2>
      <p className="info-hero__sub">How we collect, use, and protect your personal information.</p>
    </div>

    <div className="info-section">
      <p>Last updated: January 1, 2026</p>
      <h3 className="info-section__title">1. Information We Collect</h3>
      <p>We collect personal information that you voluntarily provide to us when you express an interest in obtaining information about us or our products and services, when you participate in activities on the Website or otherwise when you contact us.</p>

      <h3 className="info-section__title">2. How We Use Your Information</h3>
      <p>We use personal information collected via our Website for a variety of business purposes described below. We process your personal information for these purposes in reliance on our legitimate business interests, in order to enter into or perform a contract with you, with your consent, and/or for compliance with our legal obligations.</p>

      <h3 className="info-section__title">3. Will Your Information be Shared with Anyone?</h3>
      <p>We only share information with your consent, to comply with laws, to provide you with services (such as airline and hotel partners), to protect your rights, or to fulfill business obligations.</p>
    </div>
  </div>
);

const TermsOfService = () => (
  <div>
    <div className="info-hero">
      <div className="info-hero__eyebrow">Legal</div>
      <h2 className="info-hero__title">Terms of Service</h2>
      <p className="info-hero__sub">Please read these terms carefully before using our services.</p>
    </div>

    <div className="info-section">
      <p>Last updated: January 1, 2026</p>
      <h3 className="info-section__title">1. Agreement to Terms</h3>
      <p>By accessing our website and utilizing our travel booking services, you agree to be bound by these Terms of Service and all applicable laws and regulations.</p>

      <h3 className="info-section__title">2. Booking and Payments</h3>
      <p>All bookings are subject to availability. A deposit is required to secure your reservation, with full payment due as specified in your booking confirmation. Prices are subject to change without notice until a booking is confirmed.</p>

      <h3 className="info-section__title">3. Travel Documents</h3>
      <p>You are responsible for ensuring that all your travel documents, including passports, visas, and health certificates, are in order and valid for your intended travel. Next Dream Holiday is not liable for any issues arising from incorrect documentation.</p>
    </div>
  </div>
);

const CookiePreferences = () => (
  <div>
    <div className="info-hero">
      <div className="info-hero__eyebrow">Settings</div>
      <h2 className="info-hero__title">Cookie Preferences</h2>
      <p className="info-hero__sub">Manage how we use cookies to personalize your experience.</p>
    </div>

    <div className="info-section">
      <p>We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Save Preferences", you consent to our use of cookies according to your choices.</p>
    </div>

    <div className="info-cookie-list">
      <div className="info-cookie-item">
        <div>
          <div className="info-cookie-item__label">Essential Cookies</div>
          <div className="info-cookie-item__desc">These cookies are strictly necessary to provide you with services available through our website and to use some of its features.</div>
        </div>
        <label className="info-toggle">
          <input type="checkbox" checked disabled />
          <span className="info-toggle__slider"></span>
        </label>
      </div>

      <div className="info-cookie-item">
        <div>
          <div className="info-cookie-item__label">Performance & Analytics</div>
          <div className="info-cookie-item__desc">These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.</div>
        </div>
        <label className="info-toggle">
          <input type="checkbox" defaultChecked />
          <span className="info-toggle__slider"></span>
        </label>
      </div>

      <div className="info-cookie-item">
        <div>
          <div className="info-cookie-item__label">Marketing & Personalization</div>
          <div className="info-cookie-item__desc">These cookies are used to track visitors across websites to display ads that are relevant and engaging for the individual user.</div>
        </div>
        <label className="info-toggle">
          <input type="checkbox" />
          <span className="info-toggle__slider"></span>
        </label>
      </div>
    </div>

    <div className="info-cookie-actions">
      <button className="btn-primary">Save Preferences</button>
      <button className="btn-ghost">Accept All</button>
    </div>
  </div>
);

/* ── MAIN MODAL COMPONENT ── */

export default function InfoPagesModal({ page, onClose }) {
  if (!page) return null;

  // Render appropriate content based on page name
  const renderContent = () => {
    switch (page) {
      case 'About Us': return <AboutUs />;
      case 'Contact Us': return <ContactUs />;
      case 'FAQs': return <FAQs />;
      case 'Booking Guide': return <BookingGuide />;
      case 'Refund Policy': return <RefundPolicy />;
      case 'Travel Insurance': return <TravelInsurance />;
      case 'Travel Blog': return <TravelBlog />;
      case 'Privacy Policy': return <PrivacyPolicy />;
      case 'Terms of Service': return <TermsOfService />;
      case 'Cookie Preferences': return <CookiePreferences />;
      default: return <div>Page not found</div>;
    }
  };

  return (
    <div className="info-overlay" onClick={onClose}>
      <div className="info-modal" onClick={e => e.stopPropagation()}>
        <div className="info-modal__header">
          <div className="info-modal__header-left">
            <div className="info-modal__icon">
              <PageIcon />
            </div>
            <div>
              <div className="info-modal__brand">Next Dream Travel</div>
              <div className="info-modal__page-title">{page}</div>
            </div>
          </div>
          <button className="info-modal__close" onClick={onClose} aria-label="Close">
            <CloseIcon />
          </button>
        </div>
        <div className="info-modal__body">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}
